<template>
  <div 
    class="FileThumbnails" 
    :class="{ 'FileThumbnails--wide': wide }">
    <FileThumnail 
      v-for="file in files" 
      :key="`file-${file.uuid}`"
      :uuid="file.uuid"
      :disabled="disabled"
      :linklabel="linklabel"
      :filenameprefix="filenameprefix"
      @disconnect="handleDisconnectFile" />
  </div>
</template>

<script>
import FileThumnail from '@/components/files/FileThumbnail.vue'

export default {
  name: 'FileThumbnails',
  components: {
    FileThumnail
  },
  props: {
    files: {
      type: Array,
      required: true
    },
    wide: {
      type: Boolean,
      default: true
    },
    linklabel: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: true
    },
    filenameprefix: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleDisconnectFile({ uuid }) {
      this.$emit('disconnect', { uuid })
    }
  }
}
</script>
<style lang="scss">

.FileThumbnails {
  list-style: none;
  margin: 0;
  padding: 10px;
  background: $neutral-grey1;
  position: relative;
  display: inline-block;
  width: calc(50% - 5px);
  margin-bottom: 1rem;

  &:nth-child(2n + 2) {
    margin-left: 10px;
  }

  &.FileThumbnails--wide {
    width: 100%;
    margin-left: 0;

    .btns {
      display: flex;
      justify-content: space-between;

      button {
        display: inline-block;
      }
    }
  }


  .b-aspect-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    display: inline-block;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }


  .text-button {
    display: flex;
    align-items: center;
    font-family: inherit;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: $primary-darkblue;
    fill: $primary-darkblue;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    cursor: pointer;

    .text-button__label {
      @include breakpoint('s') {
        display: none;
      }
    }

    &:hover {
      color: $primary-red;
      fill: $primary-red;
    }

    &:focus,
    &:active {
      outline: 2px solid $primary-black;
    }

    .b-icon {
      margin-right: 0.3em;
    }
  }
  .b-icon {
    width: 14px;
  }
}

</style>
